import React from "react";
import Ramos from "components/Ramos/Ramos";

//import Perfil from "components/Perfil/Perfil";
//import Rcontrasena from "components/Login/Recuperar_contrasena";
//import Camcontrasena from "components/Perfil/Cambiar_contrasena";

class Home extends React.Component {
  // constructor(props){
  //   super(props);
  //   this.state={isLogin:localStorage.getItem("login")}
  // }
  render() {

      return (
        <main className="cr-app bg-light">
          <div className="cr-content container-fluid">
            <Ramos />
          </div>
        </main>
      );
    
  }
}

export default Home;
